import { render, staticRenderFns } from "./userimageuploader.component.vue?vue&type=template&id=57bb4eea&scoped=true"
import script from "./userimageuploader.component.vue?vue&type=script&lang=js"
export * from "./userimageuploader.component.vue?vue&type=script&lang=js"
import style0 from "./userimageuploader.component.vue?vue&type=style&index=0&id=57bb4eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bb4eea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VCard,VImg})
